export default "__VITE_ASSET__DaEaEONG__"